// extracted by mini-css-extract-plugin
export var createdDate = "_jv-1";
export var divider = "_jv-2";
export var headerDivider = "_jv-3";
export var messagesCard = "_jv-0";
export var messagesContainer = "_jv-7";
export var messagesContainerWrapper = "_jv-4";
export var pointerCapturingButtonBoxes = "_jv-a";
export var showLeftPanelButton = "_jv-9";
export var showMoreButton = "_jv-c";
export var showMoreButtonContainer = "_jv-b";
export var summaryTitle = "_jv-6";
export var systemMessageCardWrapper = "_jv-d";
export var topButtons = "_jv-8";
export var withPadding = "_jv-5";